
import React from "react";

interface IntermediateTierDataProps {
  tierData: any;
}

export default function IntermediateTierData({ tierData }: IntermediateTierDataProps) {
  if (!tierData) return <p className="text-white/70">No tier data available</p>;
  
  return (
    <div className="space-y-3">
      {tierData.trainingHistory && (
        <div className="flex">
          <span className="text-white/80 w-40">Training History:</span>
          <span className="text-white">{tierData.trainingHistory.replace(/_/g, " ")}</span>
        </div>
      )}
      {tierData.currentRoutine && (
        <div className="flex">
          <span className="text-white/80 w-40">Current Routine:</span>
          <span className="text-white">{tierData.currentRoutine}</span>
        </div>
      )}
      {tierData.plateaus && (
        <div className="flex">
          <span className="text-white/80 w-40">Plateaus:</span>
          <span className="text-white">{tierData.plateaus}</span>
        </div>
      )}
      {tierData.performanceMetrics && (
        <div className="flex">
          <span className="text-white/80 w-40">Performance Metrics:</span>
          <span className="text-white">{tierData.performanceMetrics}</span>
        </div>
      )}
    </div>
  );
}
